import './badge.scss';

class Badge {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-badge',
            targetValue: 'target'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$target = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.targetValue}"]`);
    }

    initialize () {
        if (this.$target) {
            this.setEvents();
            this.setMinSize(true);
        }
    }

    setMinSize (add) {
        if (add) {
            let min = this.$target.offsetHeight;

            if (this.$target.offsetWidth > min) {
                min = this.$target.offsetWidth;
            }

            this.$target.style.minWidth = `${min}px`;
            this.$target.style.minHeight = `${min}px`;
        } else {
            this.$target.style = '';
            this.setMinSize(true);
        }
    }

    setEvents () {
        window.addEventListener('resize', () => {
            this.setMinSize(false);
        });
    }
}

export { Badge };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-badge="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new Badge($root);
            $rootAPI.initialize();
        });
    }
});
